import {
  BadgeCheck,
  BookOpen,
  Boxes,
  Calculator,
  CalendarClock,
  LayoutGrid,
  type LucideIcon,
  MessageSquareWarning,
  RefreshCw,
  Scissors,
  Settings,
  Store,
} from "lucide-react";

/**
 * Explicit registry for the database-driven `apps.icon` column.
 *
 * A namespace import (`import * as Icons from "lucide-react"`) would let any
 * icon name resolve dynamically, but it also defeats tree-shaking and drags the
 * entire ~1500-icon set into the bundle. Registering the icons we actually use
 * keeps the client small; an unknown name falls back to LayoutGrid.
 *
 * Adding a new tile icon means adding it here as well as in the seed.
 */
const REGISTRY: Record<string, LucideIcon> = {
  BadgeCheck,
  BookOpen,
  Boxes,
  Calculator,
  CalendarClock,
  LayoutGrid,
  MessageSquareWarning,
  RefreshCw,
  Scissors,
  Settings,
  Store,
};

export function resolveIcon(name: string): LucideIcon {
  return REGISTRY[name] ?? LayoutGrid;
}
